import { Component, OnInit } from "@angular/core";
import { UserMgmtService } from "../user.service";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { ExcelService } from "../../../shared/excel.service";
import { DashboardService } from "../../dashboard/dashboard.service";
@Component({
  selector: "app-user-analytics",
  templateUrl: "./user-analytics.component.html",
  styleUrls: ["./user-analytics.component.scss"],
})
export class UserAnalyticsComponent implements OnInit {
  userList = [];
  total: number = 0;
  pageLimit: number = 10;
  currentPage: number = 0;
  totalPage: number;
  isLoading: boolean = false;
  searchStartDate: any;
  searchEndDate: any;
minDate: any = new Date(2022, 0, 1);   
maxDate: any = new Date(2050, 11, 31); 
  modalRef: NgbModalRef;
  modalOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  selectedUserBookingData: any;
  closeResult: string;
  selectedTab: string = 'lastMonth';
  inactiveCount: number = 0;
  searchText: string = '';
  selectedBookingCount: string = "";
  customBookingCount: number = 0;
  private searchSubject: Subject<string> = new Subject<string>();

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private excelService: ExcelService,
    private DashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.getUserCountData();

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(() => {
      this.currentPage = 0;
      this.updateQueryParams();
    });

    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.applyTabFilter('lastMonth', true);
      } else {
        this.selectedTab = params['tab'] || 'lastMonth';
        this.searchText = params['text'] || '';
        this.selectedBookingCount = params['bookingCount'] || '';
        this.customBookingCount = params['customCount'] ? +params['customCount'] : 0;
        this.currentPage = params['page'] ? +params['page'] : 0;
        this.pageLimit = params['limit'] ? +params['limit'] : 10;
        
        if (params['startDate']) {
          const parts = params['startDate'].split('-');
          this.searchStartDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          this.searchStartDate = null;
        }

        if (params['endDate']) {
          const parts = params['endDate'].split('-');
          this.searchEndDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          this.searchEndDate = null;
        }

        this.fetchUserDetails(true);
      }
    });
  }

  userCounts:any;
  getUserCountData(){
     this.DashboardService.getUserCountsApi().subscribe(
      (res) => {
        if (res["statusCode"] === 200) {
          this.userCounts = res["data"];
          console.log(this.userCounts)
        }
      },
      (err) => {
        console.error("Error fetching user counts", err);
      }
    );
  }

  updateQueryParams() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab: this.selectedTab,
        startDate: this.searchStartDate ? this.formatDate(this.searchStartDate) : null,
        endDate: this.searchEndDate ? this.formatDate(this.searchEndDate) : null,
        text: this.searchText || null,
        bookingCount: this.selectedBookingCount || null,
        customCount: this.customBookingCount || null,
        page: this.currentPage > 0 ? this.currentPage : null,
        limit: this.pageLimit !== 10 ? this.pageLimit : null
      },
      queryParamsHandling: 'merge',
    });
  }

  applyTabFilter(filter: string, updateUrl: boolean = true) {
    this.selectedTab = filter;
    const now = new Date();
    this.searchEndDate = now;
    
    if (filter === 'lastWeek') {
      const lastWeek = new Date();
      lastWeek.setDate(now.getDate() - 7);
      this.searchStartDate = lastWeek;
    } else if (filter === 'lastMonth') {
      const lastMonth = new Date();
      lastMonth.setMonth(now.getMonth() - 1);
      this.searchStartDate = lastMonth;
    } else if (filter === 'last3Month') {
      const last3Month = new Date();
      last3Month.setMonth(now.getMonth() - 3);
      this.searchStartDate = last3Month;
    } else if (filter === 'last6Month') {
      const last6Month = new Date();
      last6Month.setMonth(now.getMonth() - 6);
      this.searchStartDate = last6Month;
    } else if (filter === 'all') {
      this.searchStartDate = null;
      this.searchEndDate = null;
    } else if (filter === 'custom') {
      // Initialize with 2024-2050 range if not set
      this.minDate = new Date(2022, 0, 1);
      this.maxDate = new Date(2050, 11, 31);
      if (updateUrl) {
        this.updateQueryParams();
      }
      return;
    }

    this.currentPage = 0;
    if (updateUrl) {
      this.updateQueryParams();
    }
  }

  viewDetail(userId: string) {
    if (userId) {
      this.router.navigate(['/main/user-management/user-analytics-detail', userId], {
        queryParamsHandling: 'preserve'
      });
    }
  }

  formatDate(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  fetchUserDetails(showLoader: boolean = true) {
    if (showLoader) {
      this.isLoading = true;
    }
    const offset = this.currentPage * this.pageLimit;
    
    let query = `offset=${offset}&limit=${this.pageLimit}&expand=addresses&expand=lastBooking&lastBookedExclude=true&expand=bookingData`;
    
    if (this.searchStartDate) {
      query += `&lastBookedFrom=${this.formatDate(this.searchStartDate)}`;
    }
    if (this.searchEndDate) {
      query += `&lastBookedTo=${this.formatDate(this.searchEndDate)}`;
    }
    if (this.searchText) {
      query += `&text=${this.searchText.trim()}`;
    }

    // Add totalBookings filter
    if (this.selectedBookingCount === 'custom') {
      query += `&totalBookings=${this.customBookingCount}`;
    } else if (this.selectedBookingCount !== '') {
      query += `&totalBookings=${this.selectedBookingCount}`;
    }

    this.userMgmtService.getUserListApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["statusCode"] === 200) {
          this.userList = res["data"]["userList"];
          this.total = res["data"]["totalCount"];
          this.calculateStats();
          this.setPagination();
        } else {
          this.userList = [];
          this.total = 0;
        }
      },
      (err) => {
        this.isLoading = false;
        this.userList = [];
        this.total = 0;
      }
    );
  }

  calculateStats() {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    
    this.inactiveCount = this.userList.filter(user => {
      if (user.bookingData && user.bookingData.lastBookingDate) {
        const lastBooking = new Date(user.bookingData.lastBookingDate);
        return lastBooking < oneMonthAgo;
      }
      return true; // No booking usually means inactive if it was created long ago, but here we just follow reference
    }).length;
  }

  setPagination() {
    this.totalPage = Math.ceil(this.total / this.pageLimit);
    if (this.totalPage === 0) this.totalPage = 1;
  }

  nextPage() {
    if (this.currentPage + 1 < this.totalPage) {
      this.currentPage++;
      this.updateQueryParams();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updateQueryParams();
    }
  }

  changePageLimit() {
    this.currentPage = 0;
    this.updateQueryParams();
  }

  searchFiltersBtn(showLoader: boolean = true) {
    this.currentPage = 0;
    this.updateQueryParams();
  }

  onReset() {
    this.searchText = '';
    this.selectedBookingCount = '';
    this.customBookingCount = 0;
    this.applyTabFilter('lastMonth');
  }

  onBookingFilterChange() {
    if (this.selectedBookingCount !== 'custom') {
      this.searchFiltersBtn();
    }
  }

  onSearchChange() {
    this.searchSubject.next(this.searchText);
  }

  onExport() {
    this.isLoading = true;
    
    // Construct query without offset and limit, adding fetchAll=true
    let query = `expand=addresses&expand=lastBooking&lastBookedExclude=true&expand=bookingData&fetchAll=true`;
    
    if (this.searchStartDate) {
      query += `&lastBookedFrom=${this.formatDate(this.searchStartDate)}`;
    }
    if (this.searchEndDate) {
      query += `&lastBookedTo=${this.formatDate(this.searchEndDate)}`;
    }
    if (this.searchText) {
      query += `&text=${this.searchText.trim()}`;
    }

    if (this.selectedBookingCount === 'custom') {
      query += `&totalBookings=${this.customBookingCount}`;
    } else if (this.selectedBookingCount !== '') {
      query += `&totalBookings=${this.selectedBookingCount}`;
    }

    this.userMgmtService.getUserListApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["statusCode"] === 200) {
          const list = res["data"]["userList"] || [];
          if (list.length > 0) {
            this.excelService.generateExcel(list);
          } else {
             // Show message if no data to export
          }
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  changeStartDate() {
  }

  changeEndDate() {
    this.maxDate = this.searchEndDate;
  }

  getFrequency(bookingData: any): string {
    if (!bookingData || !bookingData.howOftens) {
      return "--";
    }
    const howOftens = bookingData.howOftens;
    const keys = Object.keys(howOftens);
    if (keys.length === 0) {
      return "--";
    }
    return keys.map((key) => `${key} (${howOftens[key]})`).join(", ");
  }

  getFrequencyShort(howOftens: any): string {
    if (!howOftens) return "--";
    const keys = Object.keys(howOftens);
    if (keys.length === 0) return "--";
    // Show the first frequency or join them if multiple
    return keys.map(k => k.charAt(0).toUpperCase() + k.slice(1)).join(", ");
  }

  openFrequencyModal(row, content) {
    this.selectedUserBookingData = row.bookingData;
    this.modalOptions = {
        backdrop: "static",
        keyboard: false,
        size: "md",
        centered: true,
      };
  
      this.modalRef = this.modalService.open(content, this.modalOptions);
      this.modalRef.result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
